import { Component } from 'vue-property-decorator';
import initDataWithoutQuery from 'src/mixin/initDataWithoutQuery';

@Component
export default class OperateFavorData extends initDataWithoutQuery {
  get inOperation() {
    return this.$store.state.isInOperation;
  }

  get selectedList() {
    return this.$store.state.selectedFavorIdList;
  }

  changeList(id: string) {
    this.$store.commit('SET_LIST', id);
  }

  selectAll() {
    this.$store.commit('SET_LIST', this.data.map(item => item.id));
  }
}
